<template>
  <div class="solution-section">
    <div class="content">
      <section-heading :text="content.heading" />
      <p class="text"> {{ content.text }} </p>
    </div>
    <div class="solution-slider">
      <info-block-slider
        class="info-block-slider"
        :items="content.items" />
    </div>
  </div>
</template>
<script>

import InfoBlockSlider from '../components/InfoBlockSlider'
import SectionHeading from '../components/SectionHeading'
import { trackSection } from '../utils/track.js'

export default {
  components: {
    InfoBlockSlider,
    SectionHeading
  },
  data () {
    return {
      tracked: false
    }
  },
  mounted () {
    window.addEventListener('scroll', () => {
      this.checkTracker()
    })
  },
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    id: {
      type: String,
      default: ''
    },
    tracking: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    checkTracker () {
      if (this.$el.classList.contains('in-viewport', 'above-viewport')) {
        if (!this.tracked) {
          this.tracked = true
          trackSection(this.tracking.trackingId)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .solution-section {
    position: relative;
    color: $nos-op3-white;
    z-index: 10;
  }
  .content {
    max-width: 600px;
    width: 100%;
    margin: auto auto;
    padding: 50px 30px;
  }
  .text {
    margin-bottom: 15px;
    font-size: 18px;
    line-height: 28px;
  }
  .bold {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/sections/SolutionSection.vue